var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6 51.2C32.3895 51.2 38.901 48.5029 43.7019 43.7019C48.5029 38.901 51.2 32.3895 51.2 25.6C51.2 18.8105 48.5029 12.299 43.7019 7.49807C38.901 2.69714 32.3895 0 25.6 0C18.8105 0 12.299 2.69714 7.49807 7.49807C2.69714 12.299 0 18.8105 0 25.6C0 32.3895 2.69714 38.901 7.49807 43.7019C12.299 48.5029 18.8105 51.2 25.6 51.2ZM37.4624 23.3376L27.8624 13.7376C27.2623 13.1377 26.4485 12.8007 25.6 12.8007C24.7515 12.8007 23.9377 13.1377 23.3376 13.7376L13.7376 23.3376C13.1547 23.9411 12.8322 24.7495 12.8394 25.5885C12.8467 26.4275 13.1833 27.2301 13.7766 27.8234C14.3699 28.4167 15.1725 28.7533 16.0115 28.7606C16.8505 28.7678 17.6589 28.4453 18.2624 27.8624L22.4 23.7248V35.2C22.4 36.0487 22.7371 36.8626 23.3373 37.4627C23.9374 38.0629 24.7513 38.4 25.6 38.4C26.4487 38.4 27.2626 38.0629 27.8627 37.4627C28.4629 36.8626 28.8 36.0487 28.8 35.2V23.7248L32.9376 27.8624C33.5411 28.4453 34.3495 28.7678 35.1885 28.7606C36.0275 28.7533 36.8301 28.4167 37.4234 27.8234C38.0167 27.2301 38.3533 26.4275 38.3606 25.5885C38.3678 24.7495 38.0453 23.9411 37.4624 23.3376Z",
    fill: "#0F1453"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.0412b61791d55ba11603cc4c352fde47.svg";
export { ForwardRef as ReactComponent };